import {IPagination} from "../_apiResponse";
import { emptyProvider, Provider } from "../providers/_models";
import { Entity } from "app/models/entity";

export interface MeansPaginated extends IPagination<Mean>{}
export interface Mean extends Entity
{
    code?: string;
    license_plate: string;
    seats?: number;
    emission_class?: string;
    brand?: string;
    model?: string;
    kilometers?: number;
    available: boolean;
    provider?: Provider;
    meanHoursAbsences: Array<any>;
    meanDaysAbsences: Array<any>;
}

export const emptyMean: Mean = {
    id: 0,
    license_plate: '',
    available: false,
    provider: emptyProvider,
    meanHoursAbsences: [],
    meanDaysAbsences: [],
}
